












import { Vue, Component, Prop } from 'vue-property-decorator';

/**
 * Pagina default que NotFound.
 */
@Component
export default class NotFoundPage extends Vue {
    @Prop({type: Boolean, default: true}) hideToolbar: boolean;

    goBack() {
        this.$router.back();
    }
}
